<div class="report-img-container">
  <img class="report-image" src='{{stepinfo.fileName}}' (click)="openImage(stepinfo.fileName)" />
</div>


